import { Injectable } from "@angular/core";
import { init as initApm, ApmBase } from "@elastic/apm-rum";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class ApmService {
    private apm: ApmBase | undefined;

    constructor() {
        this.initApm();
    }

    public initApm() {
        this.apm = initApm({
            serviceName: environment.apmServiceName,
            serverUrl: environment.apmServerUrl,
            environment: environment.apmEnvironment,
            distributedTracing: environment.apmDistributedTracing === "true",
            distributedTracingOrigins: [environment.apmDistributedTracingOrigins], // Ensure API domain is added
            pageLoadTransactionName: window.location.pathname, // Track page loads
            active: environment.apmEnabled === "true",
        });
    }

    public renameCurrentTransaction(newName: string) {

        const apm = this.getInstance();
        const transaction = apm?.getCurrentTransaction();

        if (transaction) {
            transaction.name = newName;
        }
    }

    getInstance(): ApmBase | undefined{
        return this.apm;
    }
}
    